import React from 'react';

interface BaselineDeltaProps {
  changeValue: number | null | undefined;
  formatter: (val: number) => string;
  invertColor?: boolean;
}

export const BaselineDelta: React.FC<BaselineDeltaProps> = ({ changeValue, formatter, invertColor = false }) => {
  if (changeValue === null || changeValue === undefined || Number.isNaN(changeValue)) {
    return null;
  }

  const absValue = Math.abs(changeValue);
  if (absValue < 0.1) return null; // Don't show for negligible changes

  const color =
    changeValue === 0
      ? '#8c8c8c'
      : changeValue > 0
        ? invertColor ? '#ff4d4f' : '#52c41a'
        : invertColor ? '#52c41a' : '#ff4d4f';

  return (
    <div style={{ marginTop: 4, lineHeight: 1.1 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color }}>{formatter(changeValue)}</div>
      <div style={{ fontSize: 9, letterSpacing: 0.6, color: '#8c8c8c' }}>PRVS BASELINE CHG</div>
    </div>
  );
};

